// 'input' is the default change event for v-model directive in Vue.js v2
export default {
    methods: {
        emitInput(value) {
            this.$emit('input', value);
        },
    },
};
